import * as Yup from 'yup';
import { 
    validateAmount,
    validateDate,
    validateFloat,
    validateNumericId,
    validateTargetType, 
} from "@/Shared/Helpers";
import { TransactionEnums } from '@/Shared';


export type TransactionFormValues = {
    
    advisorId : number,
    clientId: number,
    transactionDate : string,
    bookingDate : string,
    mandateId : number,
    propertyId: number,
    needId : number,
    mandateType : string,

    operationPrice: string,
    serviceChargeProvision: string,
    acMaintenanceCharge : string,
    securityDeposit: string,
    comRate: number,
    agencyCom: string,
    clientCom: string,
    ownerCom: string
};

export const TransactionValidationSchema =  (viewEnums: TransactionEnums) => Yup.object({
    mandateType: validateTargetType(viewEnums.MandateTypeEnum),
    //propertyId: validateNumericId().required('Le bien est requis.'),
    //needId: validateNumericId().required('Le bien est requis.'),
    advisorId: validateNumericId().required('Le conseillé est requis.'),
    clientId: validateNumericId().required('Le client est requis.'),
    mandateId: validateNumericId().required('Le mandat est requis.'),
    //operationType: validateOperationType(viewEnums.OperationTypeEnum),

    transactionDate: validateDate().required('La date de transaction est requise.'),
    bookingDate: validateDate().required('La date de réservation est requise.'),

    operationPrice : validateAmount().required('Le montant du Loyer Prix Vente est requis.'),
    serviceChargeProvision : validateAmount().required('Le montant de provisions / Charges est requis.'),
    acMaintenanceCharge : validateAmount().nonNullable().notRequired(),
    securityDeposit : validateAmount().required('Le dépôt de garantie est requis.'),
    comRate : validateFloat().required('Le taux de commission est requis.'),
    agencyCom : validateAmount().required('Le frais d\'agence est requis.'),
    clientCom : validateAmount().required('Le frais à la charge du préneur est requis.'),
    ownerCom : validateAmount().required('Le frais à la charge du propriétaire est requis.'),
});
